// extracted by mini-css-extract-plugin
export default {"special-offer-wrapper":"SpecialOffer_special-offer-wrapper__i35oY"};